import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';
import firebaseConfig from '../firebase-applet-config.json';

// Initialize Firebase SDK
export const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);

// Keep the shared app database on the lite client so local dev avoids the full realtime
// Firestore watch-stream machinery during startup. Realtime-only features load the full
// client lazily where needed.
export const db = getFirestore(firebaseApp, firebaseConfig.firestoreDatabaseId || '(default)');
